module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wIJCCcc6KOnIgAAAEBJREFUOMvt1bERABAUBNFltCjTHZFfm1ECgRZOdlvASzfN2Q/iCkCtTQZGjIcC7L1kcOZDRo0aNWpUuJOIIUUvt20K60iO33UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/0.png
// module id = 245
// module chunks = 0